import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isDateInPast, isDOBRangeValid, isPresent } from 'forms/validators';

import { BasicsFormValues } from '../form/types';

export const validate = ({
  gender,
  stateId,
  dateOfBirth,
}: InitialValues<BasicsFormValues>): ValidationErrors<BasicsFormValues> => {
  const dateValidator = composeValidators(isPresent, isDateInPast, isDOBRangeValid);

  return {
    gender: isPresent(gender),
    stateId: isPresent(stateId),
    dateOfBirth: dateValidator(dateOfBirth),
  };
};
